import React from "react";
import logo from "../assets/logo.webp";
import { NavLink, useNavigate } from "react-router-dom";
import { FaHome, FaImages, FaUserTie } from "react-icons/fa";
import { IoBookSharp } from "react-icons/io5";
import { supabase } from "../../supabase";

function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login", { replace: true });
  };

  const getActiveClass = ({ isActive }) =>
    isActive ? "sidebar-nav-item active" : "sidebar-nav-item";

  return (
    <aside className="sidebar" id="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
      </div>

      <div className="sidebar-content">
        {/* ===== MAIN ===== */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">Main</div>
          <ul className="sidebar-nav">
            <NavLink to="/dashboard" className={getActiveClass}>
              <FaHome className="me-2" />
              <span>Dashboard</span>
            </NavLink>

            <NavLink to="/admin-gallery" className={getActiveClass}>
              <FaImages className="me-2" />
              <span>Gallery</span>
            </NavLink>

            <NavLink to="/admin-publications" className={getActiveClass}>
              <IoBookSharp className="me-2" />
              <span>Publications</span>
            </NavLink>
          </ul>
        </div>

        {/* ===== COMMITTEE ===== */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">Committee</div>
          <ul className="sidebar-nav">
            <NavLink to="/admin-gen-secretary" className={getActiveClass}>
              <FaUserTie className="me-2" />
              <span>Gen. Secretary</span>
            </NavLink>

            <NavLink to="/admin-presidents" className={getActiveClass}>
              <FaUserTie className="me-2" />
              <span>Presidents</span>
            </NavLink>
          </ul>
        </div>
      </div>

      {/* ===== LOGOUT ===== */}
      <div className="sidebar-footer">
        <button className="btn btn-danger w-100" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
